import { Grid, ModalTitle, Paper } from '@prometheus/components';
import { CodeEditor, FileExplorer } from '@prometheus/features';
import { TabsNavigationNew } from '@prometheus/features';
import { useEntityNew } from '@prometheus/hooks';
import React, { FC } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { NoDataContainer } from './ExecutionResults.styles';
import { getDataSourceExecutionById } from '@/api';
import { useTranslation } from 'react-i18next';

export const ExecutionResults: FC<{
  onClose: () => void;
  dataSourceId: string;
}> = ({ onClose, dataSourceId }) => {
  const { t } = useTranslation();
  const { submissionId } = useParams();
  const { entity } = useEntityNew({
    get: () => getDataSourceExecutionById(dataSourceId, submissionId),
    update: data => Promise.resolve(),
  });
  return (
    <Grid container>
      <Grid item xs={12}>
        <ModalTitle onClose={onClose}>
          {t('modules.administration.databases.jobs_result_header')}
        </ModalTitle>
        <Paper elevation={3} sx={{ borderRadius: 0 }}>
          <TabsNavigationNew
            withRouting
            tabs={[
              {
                title: t('modules.administration.tabs.log_file'),
                value: '',
                end: true,
              },
              {
                title: t('modules.administration.tabs.results'),
                value: 'results',
              },
            ]}
          />
        </Paper>
        <Grid container>
          <Grid item xs={12} p={2}>
            <Paper elevation={0}>
              <Routes>
                <Route
                  index
                  path="results"
                  element={
                    <FileExplorer url="cdm" submissionId={submissionId} />
                  }
                />
                <Route
                  index
                  element={
                    entity?.stdout ? (
                      <Grid item xs={12}>
                        <CodeEditor
                          data={entity?.stdout || ''}
                          height={'80vh'}
                          containerStyles={{ padding: 0 }}
                          enableDownload={false}
                          enableCopy
                          readOnly
                        />
                      </Grid>
                    ) : (
                      <Grid item xs={12} textAlign="center" p={2}>
                        <NoDataContainer>
                          {t('messages.logs_empty')}
                        </NoDataContainer>
                      </Grid>
                    )
                  }
                />
              </Routes>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
